import ForgotPasswordPage from "modules/admin/auth/ForgotPasswordPage";
import AdminUserCreatePasswordPage from "modules/admin/users/pages/AdminUserCreatePassword";
import AdminClientCreate from "modules/admin/clients/pages/AdminClientCreate";
import AdminClientEdit from "modules/admin/clients/pages/AdminClientEdit";
import AdminClientList from "modules/admin/clients/pages/AdminClientList";
import ListDriverPage from "modules/admin/drivers/pages/DriverListPage";
import DriverPage from "modules/admin/drivers/pages/DriverPage";
import AdditionalVehiclePage from "modules/admin/drivers/pages/AdditionalVehiclePage";
import AdminRouteList from "modules/admin/orders/pages/RouteList";
import AdminDelayedRouteList from "modules/admin/orders/pages/DelayedRouteList";
import AdminEditStopPage from "modules/admin/orders/pages/EditStop";
import AdminSettingPackageTypeEdit from "modules/admin/settings/pages/PackageTypeEdit";
import AdminSettingPackageTypeList from "modules/admin/settings/pages/PackageTypeList";
import AdminSettingPackageTypeNew from "modules/admin/settings/pages/PackageTypeNew";
import AdminSettingServiceEdit from "modules/admin/settings/pages/ServiceEdit";
import AdminSettingServiceList from "modules/admin/settings/pages/ServiceList";
import AdminSettingServiceNew from "modules/admin/settings/pages/ServiceNew";
import AdminSettingTerritoryEdit from "modules/admin/settings/pages/TerritoryEdit";
import AdminSettingTerritoryList from "modules/admin/settings/pages/TerritoryList";
import AdminSettingTerritoryNew from "modules/admin/settings/pages/TerritoryNew";
import AdminSettingSaasCountries from "modules/admin/settings/pages/SaasCountries";
import AdminSettingSaasCountriesNew from "modules/admin/settings/pages/SaasCountriesNew";
import AdminSettingVehicleCategoryEdit from "modules/admin/settings/pages/VehicleCategoryEdit";
import AdminSettingVehicleCategoryList from "modules/admin/settings/pages/VehicleCategoryList";
import AdminSettingVehicleCategoryNew from "modules/admin/settings/pages/VehicleCategoryNew";
import AdminSettingFailedRegistrationList from "modules/admin/settings/pages/FailedRegistrationList";
import AdminSettingVersionList from "modules/admin/settings/pages/VersionList";
import AdminEditUserAdmin from "modules/admin/users/pages/AdminEditUserAdmin";
import AdminEditUserClient from "modules/admin/users/pages/AdminEditUserClient";
import AdminEditUserTerritory from "modules/admin/users/pages/AdminEditUserTerritory";
import AdminUserAdminList from "modules/admin/users/pages/AdminUserAdminList";
import AdminUserClientList from "modules/admin/users/pages/AdminUserClientList";
import AdminUserCreateAdmin from "modules/admin/users/pages/AdminUserCreateAdmin";
import AdminUserCreateClient from "modules/admin/users/pages/AdminUserCreateClient";
import AdminUserCreateTerritory from "modules/admin/users/pages/AdminUserCreateTerritory";
import AdminUserTerritoryList from "modules/admin/users/pages/AdminUserTerritoryList";
import AdminLoginPage from "modules/auth/pages/AdminLoginPage";
import ConfirmRoutePageAdmin from "modules/admin/orders/pages/ConfirmRoutePageAdmin";
import AdminCreateOrderPage from "modules/admin/orders/pages/AdminCreateOrderPage";
import HistoriesPage from "modules/client/history/pages/RouteHistoryListPage";
import RouteDetailPage from "modules/client/routes/pages/RouteDetailPage";
import JobDetail from "modules/client/active-orders/pages/JobDetail";
import RouteDispatchPage from "modules/client/routes/pages/RouteDispatchPage";
import AddJob from "modules/client/active-orders/pages/AddJob";
import DashboardPage from "modules/client/dashboard";
import DashboardMapPage from "modules/client/dashboard/map";
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import PrivateAdminRoute from "routes/PrivateAdminRoute";
import DriverFeedbacksPage from "modules/admin/driver-feedback/pages/DriverFeedbacksPage";
import DriverBroadcastList from "modules/admin/driver-broadcast/pages/DriverBroadcastList";
import DriverBroadcastCreate from "modules/admin/driver-broadcast/pages/DriverBroadcastCreate";
import DriverBroadcastDetail from "modules/admin/driver-broadcast/pages/DriverBroadcastDetail";
import FacturasPageNew from "modules/admin/facturas/pages/FacturasPageNew";
import BillingDashboard from "modules/admin/facturas/pages/BillingDashboard";
import FacturaForm from "modules/admin/facturas/pages/FacturaForm";
import FlexioPoolList from "modules/admin/pool/pages/FlexioPoolList";
import PoolOrders from "modules/admin/pool/pages/PoolOrders";
import { useSelector } from "react-redux";
import { selectRole } from "modules/auth/store/authSlice";
import { UserRole } from "configs/constants";
import DelayedRouteList from "modules/admin/orders/pages/DelayedRouteList";
import PromoCode from "modules/admin/promo-code/pages/PromoCode";
import PromoCodeEdit from "modules/admin/promo-code/pages/PromoCodeEdit";
import ReportsDashboard from "modules/admin/reports/pages/ReportsDashboard";
import SalesReport from "modules/admin/reports/pages/SalesReport";
import FailedStopAnalysis from "modules/admin/reports/pages/FailedStopAnalysis";
import PoolReport from "modules/admin/reports/pages/PoolReport";
import SftpPodReport from "modules/admin/reports/pages/SftpPodReport";
import DriverCallLogReport from "modules/admin/reports/pages/DriverCallLogReport";
import AdminLocationsList from "modules/admin/locations/pages/AdminLocationsList";
import AdminLocationDetail from "modules/admin/locations/pages/AdminLocationDetail";
import AdminEntitlementsList from "modules/admin/billing/pages/AdminEntitlementsList";
import AdminEntitlementDetail from "modules/admin/billing/pages/AdminEntitlementDetail";
import TierList from "modules/admin/tiers/pages/TierList";
import TierEdit from "modules/admin/tiers/pages/TierEdit";
import BillingReportsIndex from "modules/admin/billing/reports/BillingReportsIndex";
import RevenueReport from "modules/admin/billing/reports/RevenueReport";
import ReceivablesReport from "modules/admin/billing/reports/ReceivablesReport";
import EstimateVsFinal from "modules/admin/billing/reports/EstimateVsFinal";
import RevenueAnalysis from "modules/admin/billing/reports/RevenueAnalysis";
import DriverBillingReport from "modules/admin/billing/reports/DriverBillingReport";
import AdminPlanListPage from "modules/admin/plans/pages/PlanListPage";
import AdminRoutePlanDetailPage from "modules/admin/plans/pages/RoutePlanDetailPage";
import AdminSavedRoutesPage from "modules/admin/saved-routes/pages/SavedRoutesPage";
import Pdf417GeneratorPage from "modules/admin/pdf417-generator/pages/Pdf417GeneratorPage";
import AIImportPage from "modules/client/ai-import/pages/AIImportPage";
import AdminScan2PackPage from "modules/admin/scan2pack/pages/Scan2PackPage";
import AdminToteDetailPage from "modules/admin/scan2pack/pages/ToteDetailPage";

// Wrapper component for admin AI Import
const AdminAIImportPage = (props) => <AIImportPage {...props} isAdmin={true} />;

const AdminSpace = () => {
  const role = useSelector(selectRole);
  return (
    <Switch>
      <Route exact path="/admin/login" component={AdminLoginPage} />
      <Route exact path="/admin/forgot-password" component={ForgotPasswordPage} />
      <Route
        exact
        path="/admin/create-password"
        component={AdminUserCreatePasswordPage}
      />

      <PrivateAdminRoute exact path="/admin" component={DelayedRouteList} />
      <PrivateAdminRoute exact path="/admin/dashboard" component={DashboardPage} />
      <PrivateAdminRoute exact path="/admin/dashboard/map" component={DashboardMapPage} />
      <PrivateAdminRoute exact path="/admin/ai-import" component={AdminAIImportPage} />
      {role === UserRole.ADMIN && (
        <PrivateAdminRoute
          exact
          path="/admin/users/admins"
          component={AdminUserAdminList}
        />
      )}
      {role === UserRole.ADMIN && (
        <PrivateAdminRoute
          exact
          path="/admin/users/clients"
          component={AdminUserClientList}
        />
      )}
      {role === UserRole.ADMIN && (
        <PrivateAdminRoute
          exact
          path="/admin/users/territories"
          component={AdminUserTerritoryList}
        />
      )}
      {role === UserRole.ADMIN && (
        <PrivateAdminRoute exact path="/admin/users/drivers" component={ListDriverPage} />
      )}
      <PrivateAdminRoute exact path="/admin/users/drivers/new" component={DriverPage} />
      <PrivateAdminRoute exact path="/admin/users/drivers/:id" component={DriverPage} />
      <PrivateAdminRoute
        exact
        path="/admin/users/drivers/:id/add-additional-vehicle"
        component={AdditionalVehiclePage}
      />
      <PrivateAdminRoute
        exact
        path="/admin/users/drivers/:id/add-additional-vehicle/:additionalVehicleId/edit"
        component={AdditionalVehiclePage}
      />

      <PrivateAdminRoute
        exact
        path="/admin/users/territories/new"
        component={AdminUserCreateTerritory}
      />

      <PrivateAdminRoute
        exact
        path="/admin/users/clients/new"
        component={AdminUserCreateClient}
      />

      <PrivateAdminRoute
        exact
        path="/admin/users/admins/new"
        component={AdminUserCreateAdmin}
      />
      <PrivateAdminRoute
        exact
        path="/admin/users/clients/:id"
        component={AdminEditUserClient}
      />
      <PrivateAdminRoute
        exact
        path="/admin/users/territories/:id"
        component={AdminEditUserTerritory}
      />
      <PrivateAdminRoute
        exact
        path="/admin/users/admins/:id"
        component={AdminEditUserAdmin}
      />
      <PrivateAdminRoute exact path="/admin/clients" component={AdminClientList} />
      <PrivateAdminRoute exact path="/admin/clients/new" component={AdminClientCreate} />
      <PrivateAdminRoute exact path="/admin/clients/:id" component={AdminClientEdit} />
      {role !== UserRole.VIEWER && (
        <PrivateAdminRoute
          exact
          path="/admin/settings/package-types"
          component={AdminSettingPackageTypeList}
        />
      )}
      <PrivateAdminRoute
        exact
        path="/admin/settings/package-types/new"
        component={AdminSettingPackageTypeNew}
      />
      <PrivateAdminRoute
        exact
        path="/admin/settings/package-types/:id"
        component={AdminSettingPackageTypeEdit}
      />
      {role !== UserRole.VIEWER && (
        <PrivateAdminRoute
          exact
          path="/admin/settings/vehicle-categories"
          component={AdminSettingVehicleCategoryList}
        />
      )}
      <PrivateAdminRoute
        exact
        path="/admin/settings/vehicle-categories/new"
        component={AdminSettingVehicleCategoryNew}
      />
      <PrivateAdminRoute
        exact
        path="/admin/settings/vehicle-categories/:id"
        component={AdminSettingVehicleCategoryEdit}
      />
      {role !== UserRole.VIEWER && (
        <PrivateAdminRoute
          exact
          path="/admin/settings/services"
          component={AdminSettingServiceList}
        />
      )}
      <PrivateAdminRoute
        exact
        path="/admin/settings/services/new"
        component={AdminSettingServiceNew}
      />
      <PrivateAdminRoute
        exact
        path="/admin/settings/services/:id"
        component={AdminSettingServiceEdit}
      />
      {role !== UserRole.VIEWER && (
        <PrivateAdminRoute
          exact
          path="/admin/settings/territories"
          component={AdminSettingTerritoryList}
        />
      )}
      <PrivateAdminRoute
        exact
        path="/admin/settings/territories/new"
        component={AdminSettingTerritoryNew}
      />
      <PrivateAdminRoute
        exact
        path="/admin/settings/territories/:id"
        component={AdminSettingTerritoryEdit}
      />
      {role !== UserRole.VIEWER && (
        <PrivateAdminRoute
          exact
          path="/admin/settings/saas-countries"
          component={AdminSettingSaasCountries}
        />
      )}
      <PrivateAdminRoute
        exact
        path="/admin/settings/saas-countries/new"
        component={AdminSettingSaasCountriesNew}
      />
      <PrivateAdminRoute
        exact
        path="/admin/settings/failed-registration"
        component={AdminSettingFailedRegistrationList}
      />
      <PrivateAdminRoute
        exact
        path="/admin/settings/version"
        component={AdminSettingVersionList}
      />
      <PrivateAdminRoute exact path="/admin/routes" component={AdminRouteList} />
      <PrivateAdminRoute exact path="/admin/plans" component={AdminPlanListPage} />
      <PrivateAdminRoute exact path="/admin/scan2pack" component={AdminScan2PackPage} />
      <PrivateAdminRoute
        exact
        path="/admin/routeplan/:id"
        component={AdminRoutePlanDetailPage}
      />
      <PrivateAdminRoute exact path="/admin/tote/:id" component={AdminToteDetailPage} />
      <PrivateAdminRoute
        exact
        path="/admin/saved-routes"
        component={AdminSavedRoutesPage}
      />
      <PrivateAdminRoute
        exact
        path="/admin/delayed-routes"
        component={AdminDelayedRouteList}
      />
      <PrivateAdminRoute exact path="/admin/routes/:id" component={RouteDetailPage} />
      <PrivateAdminRoute
        exact
        path="/admin/routes/:id/dispatch"
        component={RouteDispatchPage}
      />
      <PrivateAdminRoute exact path="/admin/routes/:id/:eid" component={JobDetail} />
      <PrivateAdminRoute exact path="/admin/routes/:id/:eid/add-job" component={AddJob} />
      <PrivateAdminRoute exact path="/admin/jobs/new" component={AdminCreateOrderPage} />
      <PrivateAdminRoute
        exact
        path="/admin/jobs/confirm-route"
        component={ConfirmRoutePageAdmin}
      />
      <Route exact path="/admin/invoicing">
        <Redirect to="/admin/billing-dashboard" />
      </Route>
      <PrivateAdminRoute
        exact
        path="/admin/billing-dashboard"
        component={BillingDashboard}
      />
      <PrivateAdminRoute exact path="/admin/facturas" component={FacturasPageNew} />
      <PrivateAdminRoute exact path="/admin/facturas/create" component={FacturaForm} />
      <PrivateAdminRoute exact path="/admin/facturas/edit/:id" component={FacturaForm} />
      <PrivateAdminRoute
        exact
        path="/admin/billing/entitlements"
        component={AdminEntitlementsList}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/entitlements/new"
        component={AdminEntitlementDetail}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/entitlements/:id"
        component={AdminEntitlementDetail}
      />
      <PrivateAdminRoute exact path="/admin/billing/tiers" component={TierList} />
      <PrivateAdminRoute exact path="/admin/billing/tiers/create" component={TierEdit} />
      <PrivateAdminRoute
        exact
        path="/admin/billing/tiers/:id/edit"
        component={TierEdit}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/reports"
        component={BillingReportsIndex}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/reports/revenue"
        component={RevenueReport}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/reports/receivables"
        component={ReceivablesReport}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/reports/estimate-vs-final"
        component={EstimateVsFinal}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/reports/revenue-analysis"
        component={RevenueAnalysis}
      />
      <PrivateAdminRoute
        exact
        path="/admin/billing/reports/drivers"
        component={DriverBillingReport}
      />
      <PrivateAdminRoute exact path="/admin/history" component={HistoriesPage} />
      <PrivateAdminRoute
        exact
        path="/admin/routes/:routeId/stops/:id/edit"
        component={AdminEditStopPage}
      />
      <PrivateAdminRoute
        exact
        path="/admin/driver-feedbacks"
        component={DriverFeedbacksPage}
      />
      <PrivateAdminRoute
        exact
        path="/admin/driver-broadcasts"
        component={DriverBroadcastList}
      />
      <PrivateAdminRoute
        exact
        path="/admin/driver-broadcasts"
        component={DriverBroadcastList}
      />
      <PrivateAdminRoute
        exact
        path="/admin/driver-broadcasts/new"
        component={DriverBroadcastCreate}
      />
      <PrivateAdminRoute
        exact
        path="/admin/driver-broadcasts/:id"
        component={DriverBroadcastDetail}
      />
      <PrivateAdminRoute exact path="/admin/pool/packages" component={FlexioPoolList} />
      <PrivateAdminRoute exact path="/admin/pool/orders" component={PoolOrders} />
      <PrivateAdminRoute exact path="/admin/pool/promo-codes" component={PromoCode} />
      <PrivateAdminRoute
        exact
        path="/admin/pool/promo-codes/edit/:id"
        component={PromoCodeEdit}
      />
      <PrivateAdminRoute exact path="/admin/reports" component={ReportsDashboard} />
      <PrivateAdminRoute exact path="/admin/reports/sales" component={SalesReport} />
      <PrivateAdminRoute exact path="/admin/reports/pool" component={PoolReport} />
      <PrivateAdminRoute
        exact
        path="/admin/reports/failed-stop-analysis"
        component={FailedStopAnalysis}
      />
      <PrivateAdminRoute
        exact
        path="/admin/reports/sftp-pod-logs"
        component={SftpPodReport}
      />
      <PrivateAdminRoute
        exact
        path="/admin/reports/driver-call-logs"
        component={DriverCallLogReport}
      />
      <PrivateAdminRoute exact path="/admin/locations" component={AdminLocationsList} />
      <PrivateAdminRoute
        exact
        path="/admin/locations/:locationId"
        component={AdminLocationDetail}
      />
      <PrivateAdminRoute
        exact
        path="/admin/pdf417-generator"
        component={Pdf417GeneratorPage}
      />
    </Switch>
  );
};
export default AdminSpace;
